module.exports = __webpack_public_path__ + "img/CM-AB-24-INFINITI-Modern.54188c9c.jpg";